"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var typestyle_1 = require("typestyle");
var Icons_1 = require("../../icons/Icons");
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var BadgeWidget_1 = require("../Badge/BadgeWidget");
var TabsWidgetStyles_1 = require("./TabsWidgetStyles");
/**
 * TabWidget is a component that renders a tab, stylized based on whether it's active, hovered, or pressed
 */
var TabWidget = /** @class */ (function (_super) {
    tslib_1.__extends(TabWidget, _super);
    function TabWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.labelRef = React.createRef();
        _this.handleMouseEnter = function () {
            var title = (DomUtil_1.isElementOverflownX(_this.labelRef.current) && _this.labelRef.current.textContent) || undefined;
            _this.setState({ title: title });
        };
        _this.handleClick = function () {
            _this.props.onClick(_this.props.index);
        };
        _this.handleFocus = function () {
            _this.props.onFocus(_this.props.index);
        };
        return _this;
    }
    TabWidget.prototype.render = function () {
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        React.createElement("div", { "aria-controls": this.props.ariaControls, "aria-selected": this.props.isActive, className: typestyle_1.classes(TabsWidgetStyles_1.TabStyleName, FocusIndicators_1.FocusVisibleIndicator), id: this.props.id, onBlur: this.props.onBlur, onClick: this.handleClick, onFocus: this.handleFocus, onMouseEnter: this.handleMouseEnter, onTouchEnd: this.handleClick, role: 'tab', style: tslib_1.__assign({}, (!!this.props.flexPercent && { flex: "1 0 " + this.props.flexPercent + "%" })), tabIndex: this.props.tabIndex, title: this.props.tabContent.title || this.state.title },
            React.createElement("div", { style: this.props.tabContainerStyles },
                React.createElement("div", { className: TabsWidgetStyles_1.DefaultTabLabelStyleName },
                    this.renderIcon(),
                    this.renderLabel()))));
    };
    TabWidget.prototype.renderIcon = function () {
        var tabIcon = this.props.tabContent.icon;
        if (!tabIcon) {
            return undefined;
        }
        var iconProps = {
            'data-tb-test-id': Declarative_1.makeTestId(this.props.id, 'icon'),
            style: TabsWidgetStyles_1.TabContentStyle
        };
        var element = (typeof tabIcon === 'string') ? React.createElement("img", { alt: '', src: Icons_1.encodeSvg(tabIcon) }) : tabIcon;
        return React.createElement("div", tslib_1.__assign({}, iconProps), element);
    };
    TabWidget.prototype.renderLabel = function () {
        var tabContent = this.props.tabContent;
        var labelProps = {
            'data-tb-test-id': Declarative_1.makeTestId(this.props.id, 'label'),
            ref: this.labelRef,
            style: TabsWidgetStyles_1.LabelStyle
        };
        return React.createElement("div", { style: TabsWidgetStyles_1.TabContentStyle },
            React.createElement("div", tslib_1.__assign({}, labelProps), tabContent.label),
            tabContent.badge && React.createElement(BadgeWidget_1.BadgeWidget, { kind: 'outline', numeric: true, children: tabContent.badge, testId: this.props.id }));
    };
    return TabWidget;
}(React.PureComponent));
exports.TabWidget = TabWidget;
//# sourceMappingURL=TabWidget.js.map